import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import ReviewQueuePage from "./index"


export const VtReviewQueueRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.REVIEW_QUEUE_PATH,
	title: VISIBILITY_TRACKER_ROUTES.REVIEW_QUEUE_TITLE,
	icon: 'list-check',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Queue-style QA of every VT resource flagged as needs_qa across the pipeline',
	// Open to QA taggers + admin. `vt_tagger` makes it appear in the
	// sidebar for QA accounts (admins see everything via the layout
	// bypass); the back scopes non-admins to their assigned retailers.
	access: USER_ROLE.VT_TAGGER,
	children: [{
		element: <ReviewQueuePage />,
		index: true,
	}],
}
